// Copyright (c) 2017 Deere & Company

import ReimbursementSummaryDetailsData, {getDefaultState as getReimbursementSummaryDetailsDataDefaultState} from './data';
import t from 'tcomb';

const State = t.struct({
    data: ReimbursementSummaryDetailsData
}, 'State');

export const getDefaultState = () =>
    new State({
        data: getReimbursementSummaryDetailsDataDefaultState()
    });

export default State;



// WEBPACK FOOTER //
// ./src/reimbursement-summary/details/state/index.js